const FormatPrice = ({ price }) => {
  return Intl.NumberFormat("bn-IN", {
    style: "currency",
    currency: "BDT",
    maximumFractionDigits: 2,
  }).format(price);
};

export default FormatPrice;
